<template>
    <div class="phone-box">
      <div class="cat-paws-bg"></div>
  
      <div class="input-group">
        <input
          v-model="phoneNumber"
          placeholder="输入手机号码喵~"
          type="tel"
          maxlength="11"
          class="meow-input"
          @keyup.enter="queryPhone"
        />
        <button 
          @click="queryPhone"
          :disabled="!isValidPhone || isLoading"
          class="meow-button"
        >
          🐱‍💻 {{ isLoading ? '正在嗅探位置...' : '查归属地ฅ' }}
        </button>
      </div>
  
      <transition name="card-flip">
        <div v-if="resultData" class="result-card">
          <div class="cat-ear-left"></div>
          <div class="cat-ear-right"></div>
          <h3>{{ phoneNumber }}</h3>
          <div class="info-item">
            <span class="label">运营商</span>
            <span class="value">{{ resultData.info.op }}</span>
          </div>
          <div class="info-item">
            <span class="label">所在地区</span>
            <span class="value">{{ resultData.info.province }} - {{ resultData.info.city }}</span>
          </div>
          <div class="info-item">
            <span class="label">邮编/区号</span>
            <span class="value">{{ resultData.info.zipcode }} / {{ resultData.info.areacode }}</span>
          </div>
        </div>
      </transition>
  
      <div v-if="errorMsg" class="error-alert">
        😿 {{ errorMsg }}
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, computed } from 'vue'
  import axios from 'axios'
  
  const apiBase = 'https://api.vvhan.com/api/phone/'
  const phoneNumber = ref('')
  const resultData = ref(null)
  const isLoading = ref(false)
  const errorMsg = ref(null)
  
  // 手机号验证
  const isValidPhone = computed(() => {
    return /^1[3-9]\d{9}$/.test(phoneNumber.value)
  })
  
  const queryPhone = async () => {
    if (!isValidPhone.value) {
      errorMsg.value = '喵~ 号码格式不对哦，要11位数字ฅ'
      return
    }
  
    try {
      isLoading.value = true
      errorMsg.value = null
      
      const { data } = await axios.get(`${apiBase}${phoneNumber.value}`)
      
      if (data.success) {
        resultData.value = data
      } else {
        throw new Error(data.message || '纸箱里的猫粮不见啦')
      }
    } catch (err) {
      errorMsg.value = err.response?.data?.message || '嗅探失败，请重试喵~'
      resultData.value = null
    } finally {
      isLoading.value = false
    }
  }
  </script>
  
  <style scoped>
  .phone-box {
    max-width: 400px;
    margin: 2rem auto;
    padding: 25px;
    background: #fff8fb;
    border-radius: 20px;
    box-shadow: 0 10px 25px rgba(255,182,193,0.15);
    position: relative;
  }
  
  .meow-input {
    width: 100%;
    padding: 12px 0px;
    border: 2px solid #ffb3cb;
    border-radius: 30px;
    font-size: 16px;
    margin-bottom: 15px;
    transition: all 0.3s;
  }
  
  .meow-input:focus {
    outline: none;
    border-color: #ff7d9f;
    box-shadow: 0 0 8px rgba(255,125,159,0.3);
  }
  
  .meow-button {
    width: 100%;
    padding: 12px;
    background: #ff9eb5;
    border: none;
    border-radius: 30px;
    color: white;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s;
  }
  
  .meow-button:hover:not(:disabled) {
    transform: scale(0.98) rotate(-1deg);
    background: #ff7d9f;
  }
  
  .result-card {
    margin-top: 25px;
    padding: 20px;
    background: white;
    border-radius: 15px;
    position: relative;
    border: 2px solid #ffd3e0;
  }
  
  .info-item {
    display: flex;
    justify-content: space-between;
    margin: 12px 0;
    padding: 8px;
    background: #fff5f8;
    border-radius: 8px;
  }
  
  .label {
    color: #ff7d9f;
    font-weight: bold;
  }
  
  .value {
    color: #666;
  }
  
  .error-alert {
    margin-top: 15px;
    padding: 12px;
    background: #ffe5e5;
    border-radius: 10px;
    color: #ff4444;
  }
  
  .cat-ear-left, .cat-ear-right {
    position: absolute;
    top: -25px;
    width: 25px;
    height: 35px;
    background: #ffb3cb;
    clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
  }
  .cat-ear-left { left: 30px; transform: rotate(-30deg); }
  .cat-ear-right { right: 30px; transform: rotate(30deg); }
  
  .card-flip-enter-active {
    animation: flipIn 0.6s ease;
  }
  
  @keyframes flipIn {
    0% { transform: perspective(400px) rotateX(90deg); opacity:0 }
    100% { transform: perspective(400px) rotateX(0); opacity:1 }
  }
  </style>
  